<template>
  <!-- 
    <div style="margin-top: 200px; height: 100px;">
          <img alt="Vue logo" src="@/assets/logo.png"/>
        </div>
        -->
        <div style="margin-left:0px;">
            <el-card class="cardArea"  shadow="always" body-style="padding: 0px;">
              <div slot="header" >
                <div class="header" style="padding:10px;">
                  <el-row>
                      <el-col :span="2" style="text-align: right;">
                        <el-avatar :size="70" >
                          <img src="/logo.png"/>
                        </el-avatar>
                      </el-col>
                      <el-col :span="22 ">
                        <div style="font-size:30px;color:#fff;text-align: left;margin-top:10px;margin-left:5px;font-weight: 600;" > 
                          <div>赣州市赣县区妇幼保健院.自助缴费机</div><!---->
                          <div style="font-size:15px;">GUAN ZHOU SHI GAN XIAN QU FU YOU BAO JIAN YUAN</div>  
                        </div>
                      </el-col>
                  </el-row>
              </div>
              </div>
              <div class="cardAreaContent" ref="cardContent"  style="padding-left:0px;padding-right:0px;padding-top:0px;">
                <div class="headermain" >
                  <el-carousel ref="teachingShow" indicator-position="outside" height="530px" :interval="2000">
                      <el-carousel-item  v-for=" c in carouselVideos" :key="c.id">
                        <!--<video width="100%"  controls autoplay muted  	loop
                            :src="c.src"
                          >
                        </video>-->
                        <img :src="c.src" style="height:100%;width:100%;"  />
                      </el-carousel-item>
                  </el-carousel>
              </div>
              <el-row type="flex"  justify="center" style="margin-top:30px">
                <el-col :span="3" v-for=" c in carouselVideos" :key="c.id">
                    <div>
                      <!-- <el-button class="teachingBtn" type="primary" :style="`background-color: ${c.color};border-color: ${c.color};`" :icon="c.icon" circle @click="showTeachingVideo(c.id)"></el-button> -->
                      <div class="buttonInstruct">
                        {{c.name}}
                      </div>
                    </div>
                </el-col>
              </el-row>
              </div>
            </el-card>
        </div>
</template>

<script>

export default {
  /*组件名称，暴露后用这个名称来import和使用，一般name和vue文件名和将来引用import名称和 注册components:{}中写的组件名称，都是同一个名称*/
  name: "MainHeader",
  /*组件数据，用于插值*/
  data() {
    return {
      carouselVideos:[] //window.appGlobal.carouselVideos
    };
  },

  /*组件的方法*/
  methods: {
    
    //接收参数
    showTeachingVideo(index){
        this.$refs.teachingShow.setActiveItem(index)
    }
  },

  /*组件属性，接收使用了组件的vue传过来的值，通过this.XXX来使用*/
  props: [],
  mounted() {
     this.carouselVideos = JSON.parse(window.appGlobal.carouselVideos)

     this.carouselVideos = JSON.parse("{}")

    this.$bus.$on('teachingVideo', (data) => {
      // console.log("收到数据：");
      // console.log("收到数据111：",data);
       if(data==="MainMenu"){
         this.carouselVideos = JSON.parse(window.appGlobal.carouselVideos)
       }else{
         this.carouselVideos=[JSON.parse(window.appGlobal[data])]
       }
    })
    
  }
};
</script>

<style scoped>
.el-header,
.el-footer {
  text-align: center;
  line-height: 20px;
}
.el-main {
  text-align: center;
}
.headermain {
  height: 530px;
}
.headerhead{
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    font-size: 30px ;
}
.buttonInstruct{
  margin-top: 10px;
  font-size: 13px ;
}
.teachingBtn{
  margin-top:7px;
}
.video-js .vjs-icon-placeholder {
    width: 100%;
    height: 100%;
    display: block;
}
.cardArea{
    background: -webkit-gradient(linear,left top,left bottom,from(#409EFF),to(#f2f4f6));
    color: #fff;
    border-radius: 10px;
    font-size: 30px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
  }
  .cardAreaContent{
    font-size:20px;
    color:#000;
    background:#fff;
    text-align: center;
    padding:10px;
  }
</style>